<template>
  <SectionRowContainer>
    <b-col>
      <h2><b>SITE IS BUILT WITH</b></h2>

      <b-row class="tech-logo-grid" cols="2">
        <b-col sm="2">
          <b-link href="https://vuejs.org/">
            <img src="../assets/logos/vuejs.png" alt="VueJS">
          </b-link>
        </b-col>

        <b-col sm="2">
          <b-link href="https://bootstrap-vue.org/">
            <img src="../assets/logos/bootstrap-vue-logo.svg" alt="Bootstrap">
          </b-link>
        </b-col>

        <b-col sm="2">
          <b-link href="https://aws.amazon.com/what-is-cloud-computing">
            <img src="https://d1.awsstatic.com/logos/aws-logo-lockups/poweredbyaws/PB_AWS_logo_RGB_stacked.547f032d90171cdea4dd90c258f47373c5573db5.png" alt="Powered by AWS Cloud Computing">
          </b-link>
        </b-col>

        <b-col sm="4"></b-col>
      </b-row>

    </b-col>
  </SectionRowContainer>
</template>

<script>
import SectionRowContainer from '../components/layout/SectionRowContainer.vue';

export default {
  name: 'SiteBuiltWithInformation',
  components: {
    SectionRowContainer
  }
}
</script>

<style lang="scss" scoped>
.tech-logo-grid {
  margin-top: 10px;
  margin-bottom: 20px;

  div {
    padding: 15px;
    text-align: center;

    img {
      width: 80%;
    }
  }
}
</style>
